import router from "@/router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

export default function applyPlugins(app) {
    const options = { transition: "fade" };
    app.use(router);
    app.use(Toast, options);
}